import React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { getDimension, getDisplayDescription, getExpiration, notNA } from "./storeCardFields";

const descriptionStyles = {
  maxWidth: "100%",
  maxHeight: "100%",
  textOverflow: "ellipsis",
  lineHeight: 1.5,
  color: "text.secondary",
};

export default function AssetCardTitle({ display, asset }) {
  const poColorLine = [asset.poNumber, asset.color].filter(notNA).join(" - ");
  const condition = notNA(asset.condition) ? asset.condition : null;
  const poColorCondition = [poColorLine, condition ? `(${condition})` : null].filter(Boolean).join(" ");

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 0.75 }}>
      {notNA(asset.skuNumber) && (
        <Typography variant="body2" fontWeight={500} color="textPrimary">
          {asset.skuNumber}
        </Typography>
      )}
      {notNA(asset.itemCode) && (
        <Typography variant="body2" fontWeight={500} color="textPrimary">
          {asset.itemCode}
        </Typography>
      )}
      <Typography
        variant="body2"
        style={descriptionStyles}
      >
        {[
          [asset.manufacturer, getDisplayDescription(asset)]
            .filter(notNA)
            .join(" "),
          [asset.model, getDimension(asset.dimensions)]
            .filter(notNA)
            .join(" "),
        ]
          .filter(v => v)
          .join(", ")}
      </Typography>
      {poColorCondition && (
        <Typography variant="body2" color="textSecondary">
          {poColorCondition}
        </Typography>
      )}
      {notNA(asset.descriptionComments) && (
        <Typography variant="body2" color="textSecondary" fontStyle="italic">
          {asset.descriptionComments}
        </Typography>
      )}
      {getExpiration(asset) && (
        <Typography variant="body2" fontWeight={500} color="textSecondary">
          Exp: {getExpiration(asset)}
        </Typography>
      )}
    </Box>
  );
}

AssetCardTitle.propTypes = {
  asset: PropTypes.object.isRequired,
};
